import http from './http'

let cachedAccess = null

const load = async (force = false) => {
  if (!cachedAccess || force) cachedAccess = (await http.get('/Telas/Acesso/GetCurrent')).data
  return cachedAccess
}

export default {
  load,
  clear () { cachedAccess = null },
  async has (moduleCode, minimumLevel = 1) {
    if (!moduleCode) return true
    const access = await load()
    return access.modules.some(item => item.moduleCode === moduleCode && item.accessLevel >= minimumLevel)
  }
}
